import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Dispatch } from 'redux';
import { EntityMenu } from '../../../shared/Domain/EntityMenu';
import { RootState } from '../../../shared/Infraestructure/AdapterStore';
import { changeSaludo } from '../../../shared/Infraestructure/SliceGenerico';

export const Controller = () => {
  let { menu } = useSelector((state: RootState) => state.auth);
  const dispatch: Dispatch = useDispatch();
  const navigate = useNavigate();

  menu = menu.filter(row => !row.esOpcion && row.sigla === 'SIGOAPP_LOGISTICA' && row.estado)

  const init = async () => {
    dispatch(changeSaludo(false));
  };
  const onClickMenu = (element: EntityMenu) => {
    navigate(`/${element.ruta}`, { replace: true });
  };

  return {
    init,
    menu,
    onClickMenu,
  };
}